module.exports = __webpack_public_path__ + "img/j.3a6a1af9.jpg";